var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 6.83416V1.52316C7.99815 1.38329 7.94109 1.24982 7.84125 1.15185C7.7414 1.05388 7.60688 0.999357 7.467 1.00016H4.543C4.4729 0.998435 4.40315 1.01064 4.3378 1.03606C4.27245 1.06148 4.21279 1.09962 4.16229 1.14827C4.11178 1.19691 4.07143 1.2551 4.04357 1.31945C4.01571 1.3838 4.0009 1.45304 4 1.52316V10.1692L3 11.0022V27.0022H25V12.0022L14.07 1.77216L8 6.83416Z",
    fill: "#F3C07B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.92 25.0032H6.08C6.04 25.0032 6 24.9632 6 24.9232V14.3932C6 13.6432 6.61 13.0332 7.36 13.0332H12.65C13.4 13.0332 14.01 13.6432 14.01 14.3932V24.9232C14 24.9632 13.96 25.0032 13.92 25.0032Z",
    fill: "#8C5543"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 19.002C12.6326 19.002 12.7598 18.9493 12.8536 18.8555C12.9473 18.7617 13 18.6346 13 18.502C13 18.3693 12.9473 18.2422 12.8536 18.1484C12.7598 18.0546 12.6326 18.002 12.5 18.002C12.3674 18.002 12.2402 18.0546 12.1464 18.1484C12.0527 18.2422 12 18.3693 12 18.502C12 18.6346 12.0527 18.7617 12.1464 18.8555C12.2402 18.9493 12.3674 19.002 12.5 19.002Z",
    fill: "#402A32"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.96 26.002H6C5.45 26.002 5 25.552 5 25.002C5 24.452 5.45 24.002 6 24.002H13.96C14.51 24.002 14.96 24.452 14.96 25.002C14.96 25.552 14.51 26.002 13.96 26.002Z",
    fill: "#D3D3D3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28 27.002H0V26.912C0 25.852 0.85 25.002 1.91 25.002H26.09C27.14 25.002 28 25.852 28 26.912V27.002Z",
    fill: "#00F397"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.88 0.3525L27.64 12.9225C28.12 13.3925 28.12 14.1525 27.64 14.6125C27.17 15.0825 26.4 15.0825 25.92 14.6125L14.02 2.8925L2.08 14.6525C1.61 15.1225 0.84 15.1225 0.36 14.6525C-0.12 14.1825 -0.12 13.4225 0.36 12.9525L13.16 0.3525C13.63 -0.1175 14.4 -0.1175 14.88 0.3525Z",
    fill: "#F8312F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.14 19.002H16.86C16.38 19.002 16 18.622 16 18.142V13.862C16 13.392 16.38 13.002 16.86 13.002H21.14C21.61 13.002 22 13.382 22 13.862V18.142C22 18.622 21.62 19.002 21.14 19.002Z",
    fill: "#83CBFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.65a01f7b69d5400e5def312b5f0c2a1a.svg";
export { ForwardRef as ReactComponent };